export default {"src":"/_next/static/media/map_pin.c4d92105.svg","height":94,"width":65,"blurWidth":0,"blurHeight":0};